package com.mgacreative.hotel.feature.inventory.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.domain.repository.PurchaseOrder
import com.mgacreative.hotel.domain.repository.PurchaseOrderItem
import com.mgacreative.hotel.domain.repository.PurchasingRepository
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

import com.mgacreative.hotel.feature.inventory.export.PdfExporter

import com.mgacreative.hotel.domain.repository.SupplierRepository
import kotlinx.coroutines.flow.MutableStateFlow
import com.mgacreative.hotel.domain.model.SupplierCategory
import com.mgacreative.hotel.domain.model.Supplier

class PurchasingViewModel(
    private val purchasingRepository: PurchasingRepository,
    private val supplierRepository: SupplierRepository,
    private val pdfExporter: PdfExporter? = null
) : ViewModel() {

    val orders: StateFlow<List<PurchaseOrder>> = purchasingRepository.observeOrders()
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = emptyList()
        )

    val categories = MutableStateFlow<List<SupplierCategory>>(emptyList())
    val suppliers = MutableStateFlow<List<Supplier>>(emptyList())

    init {
        viewModelScope.launch {
            purchasingRepository.loadOrders()
            categories.value = supplierRepository.getCategories()
            suppliers.value = supplierRepository.getSuppliers()
        }
    }

    fun createOrder(supplierName: String, items: List<PurchaseOrderItem>) {
        viewModelScope.launch {
            purchasingRepository.createOrder(supplierName, items)
        }
    }

    fun markAsDelivered(orderId: String) {
        viewModelScope.launch {
            purchasingRepository.markOrderAsDelivered(orderId)
        }
    }

    fun exportToPdf(supplierName: String) {
        viewModelScope.launch {
            try {
                // Sadece belirtilen tedarikçinin siparişlerini filtrele
                val supplierOrders = orders.value.filter { it.supplier_name.equals(supplierName, ignoreCase = true) }
                
                // Siparişlere ait item'ları topla
                val orderItemsList = mutableListOf<PurchaseOrderItem>()
                for (order in supplierOrders) {
                    val items = purchasingRepository.getOrderItems(order.id)
                    orderItemsList.addAll(items)
                }

                pdfExporter?.exportSupplierOrdersToPdf(supplierName, supplierOrders, orderItemsList)
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }
}
